import React from "react";
import { Globe } from "lucide-react";
import { useI18n } from "i18n";

// Compact language picker for PUBLIC screens. The app already defaults to the browser
// language (falling back to the tenant language on tenant-scoped pages); this lets the
// user override it for the session. Reusable on /liveness/login, /v/:token, OIDC consent.
const LANGS = [
  { code: "pt", label: "Português", flag: "🇧🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
];

export default function LanguageSwitcher({ className = "", dark = false }) {
  const { lang, setLanguage } = useI18n();
  const base = dark
    ? "bg-[#161a1f] border-[#262d36] text-slate-200"
    : "bg-white border-gray-300 text-gray-700";
  return (
    <label className={`relative inline-flex items-center ${className}`}>
      <Globe className={`absolute left-2.5 h-4 w-4 pointer-events-none ${dark ? "text-slate-400" : "text-gray-400"}`} />
      <select
        aria-label="Language"
        value={lang}
        onChange={(e) => setLanguage(e.target.value)}
        className={`appearance-none rounded-lg border pl-8 pr-7 py-1.5 text-sm cursor-pointer
          focus:outline-none focus:ring-2 focus:ring-blue-500/40 ${base}`}
      >
        {LANGS.map((l) => (
          <option key={l.code} value={l.code}>{l.flag} {l.label}</option>
        ))}
      </select>
      <svg className={`absolute right-2 h-4 w-4 pointer-events-none ${dark ? "text-slate-400" : "text-gray-400"}`}
           viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
      </svg>
    </label>
  );
}
